import React from "react";
import "./Background.css"; // We'll define the styles in a CSS file

const Background = () => {
    return (
        <div className="background">
        </div>
    );
};

export default Background;
